export default __webpack_public_path__ + "static/media/CarImages.K2700Large.f87678bc.jpg";